/**
 * Ampel-Logik nach Konzept §5.6:
 *   - grün:  Score ≥ 70
 *   - gelb:  Score 40–69
 *   - rot:   Score < 40
 */
import type { ScoreValue } from '../schema/brands.js';
import type { TrafficLight } from '../schema/score.js';

export function getTrafficLight(score: ScoreValue): TrafficLight {
  const n = score as number;
  if (n >= 70) return 'green';
  if (n >= 40) return 'yellow';
  return 'red';
}
